/**
 * Returns the iframe size based on challengeWindowSize.
 */
export function getIframeWidth(creq) {
    if (creq) {
        try {
            const { challengeWindowSize } = decode(creq);
            switch (challengeWindowSize) {
                case '01':
                    return '250px';
                case '02':
                    return '390px';
            }
        }
        catch (_) {
            // Do Nothing
        }
    }
    return '100%';
}
/**
 * Creates a new `<iframe>`.
 */
export function createIFrame(name, width, height) {
    const iframe = document.createElement('iframe');
    iframe.id = name;
    iframe.name = name;
    iframe.style.width = width;
    iframe.style.height = height;
    iframe.style.display = 'flex';
    iframe.style.flexGrow = '1';
    iframe.style.flexDirection = 'column';
    iframe.style.border = '0';
    iframe.style.margin = '0 auto';
    iframe.sandbox.add('allow-forms', 'allow-same-origin', 'allow-scripts', 'allow-pointer-lock');
    return iframe;
}
/**
 * Inserts the given `<iframe>` into the DOM element having the given selector.
 */
export function injectIframe(iframe, selector) {
    const target = selector ? document.querySelector(selector) : document.body;
    if (target) {
        target.appendChild(iframe);
    }
}
/**
 * Submits a form with type application/x-form-encoded to the page having the given method url.
 * The method page is hosted inside the iframe having the given name.
 */
export function submitToIframe(url, iframeName, params) {
    const createHiddenInput = (name, value) => {
        const result = document.createElement('input');
        result.type = 'hidden';
        result.name = name;
        result.value = value;
        return result;
    };
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.target = iframeName;
    Object.keys(params).forEach((key) => {
        form.appendChild(createHiddenInput(key, params[key]));
    });
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}
/**
 * Listens to a postMessage event.
 */
export function listenToEvent() {
    return new Promise((resolve) => {
        const listener = (event) => {
            if (event.data.type !== 'mastercard-3DSv2-TransactionMessage') {
                return;
            }
            window.removeEventListener('message', listener);
            resolve(event.data);
        };
        window.addEventListener('message', listener, false);
    });
}
/**
 * Decodes the given ACS-generated string (base64 or plain JSON).
 * This will perform a URL-safe decoding, but the string need not be URL-safe.
 */
export function decode(str) {
    try {
        const base64 = str
            .replace(/=/g, '')
            .replace(/\+/g, '-')
            .replace(/\//g, '_');
        return JSON.parse(atob(base64));
    }
    catch (error1) {
        try {
            return JSON.parse(str);
        }
        catch (error2) {
            throw new Error(`Failed to decode ACS data: ${error1} -> ${error2}`);
        }
    }
}
/**
 * Returns the last URL param of the given URL.
 */
export function getUrlParam(url) {
    var _a;
    return (_a = url === null || url === void 0 ? void 0 : url.split('/').pop()) === null || _a === void 0 ? void 0 : _a.split('?').shift();
}
//# sourceMappingURL=utils.js.map